import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";
import {
  entrepreneursAgeRangeToChart
} from "./entrepreneurs-age-range-to-chart";
import {
  entrepreneursAgeRangeChartOptions
} from "./entrepreneurs-age-range-chart-options";
import { Visibility } from "../../../../components/shared";
import { Card } from "antd";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const EntrepreneursAgeRangeChart = ({ cubeClient, filters }) => {
  const [productStageData, setProductStageData] = useState();

  useEffect(() => {
    const loadCubeQuery = async () => {
      const cubeFilters = [
        {
          "member": "Company.ageRange",
          "operator": "set"
        }
      ];

      if (filters.batchId) {
        cubeFilters.push({
          "member": "Company.batchId",
          "operator": "equals",
          "values": [filters.batchId]
        });
      }

      if (filters.programId) {
        cubeFilters.push({
          "member": "Company.programId",
          "operator": "equals",
          "values": [filters.programId]
        });
      }

      if (filters.batchRangeDates.since && filters.batchRangeDates.until) {
        const { since, until } = filters.batchRangeDates;
        const filter = {
          "member": "Company.batchStartDate",
          "operator": "inDateRange",
          "values": [since, until]
        };
        cubeFilters.push(filter);
      }

      const resultSet = await cubeClient.load({
        "measures": [
          "Company.entrepreneursCount"
        ],
        "timeDimensions": [],
        "dimensions": [
          "Company.ageRange"
        ],
        filters: cubeFilters
      });

      const queryData = resultSet.loadResponse.results[0].data;

      const chartData = entrepreneursAgeRangeToChart(queryData);
      setProductStageData(chartData);
    };


    loadCubeQuery()
      .then()
      .catch(console.error);
  }, [filters]);

  return (
    <Visibility visible={!!productStageData}>
      <Card
        style={{ marginTop: "2rem" }}
        title="Emprendedores por rango de edad">
        <Bar
          data={productStageData}
          type={"bar"}
          height={400}
          options={entrepreneursAgeRangeChartOptions} />
      </Card>
    </Visibility>
  );
};
